import {
    ApiModel,
    ApiVehicle,
    ApiVehicleConditionType,
} from '../../types/transportAssignment/transportAssignmentVehicle.types';
import { Model, Vehicle, VehicleConditionType } from '../../../sharedComponents/common.types';
import { parseOptionalStringDate } from '../../../sharedComponents/dateHelper';
import {
    mapToCategory,
    mapToCustomsInformation,
    mapToFuelType,
    mapToVehicleDimensions,
    mapToVehicleId,
    mapToVehicleType,
} from '../sharedVehicleMappers';

export const mapToVehicle = (apiVehicle: ApiVehicle): Vehicle => {
    return {
        id: mapToVehicleId(apiVehicle.id),
        model: mapToModel(apiVehicle.model),
        weight: apiVehicle.weight,
        colour: apiVehicle.colour,
        dimensions: apiVehicle.dimensions && mapToVehicleDimensions(apiVehicle.dimensions),
        vehicleType: apiVehicle.vehicle_type !== undefined ? mapToVehicleType(apiVehicle.vehicle_type) : undefined,
        licensePlate: apiVehicle.license_plate,
        specialInstructions: apiVehicle.special_instructions ?? [],
        deliveryConditions:
            apiVehicle.delivery_condition !== undefined
                ? mapToVehicleConditionType(apiVehicle.delivery_condition)
                : undefined,
        hasPriority: apiVehicle.has_priority,
        manufacturedAt: parseOptionalStringDate(apiVehicle.manufactured_at),
        customsInformation:
            apiVehicle.customs_information !== undefined
                ? mapToCustomsInformation(apiVehicle.customs_information)
                : undefined,
    };
};
const mapToModel = (apiModel: ApiModel): Model => {
    return {
        name: apiModel.name,
        modelGroup: apiModel.model_group,
        category: apiModel.category !== undefined ? mapToCategory(apiModel.category) : undefined,
        manufacturer: apiModel.manufacturer,
        fuelType: apiModel.fuel_type !== undefined ? mapToFuelType(apiModel.fuel_type) : undefined,
    };
};
export const mapToVehicleConditionType = (apiVehicleConditionType: ApiVehicleConditionType): VehicleConditionType => {
    switch (apiVehicleConditionType) {
        case ApiVehicleConditionType.CONTACT_UNKNOWN:
            return VehicleConditionType.CONTACT_UNKNOWN;
        case ApiVehicleConditionType.NO_KEYS:
            return VehicleConditionType.NO_KEYS;
        case ApiVehicleConditionType.NOT_READY_FOR_PICKUP:
            return VehicleConditionType.NOT_READY_FOR_PICKUP;
        case ApiVehicleConditionType.NOT_ON_SITE:
            return VehicleConditionType.NOT_ON_SITE;
        case ApiVehicleConditionType.NOT_READY_TO_MOVE:
            return VehicleConditionType.NOT_READY_TO_MOVE;
        case ApiVehicleConditionType.NOT_READY_TO_DRIVE:
            return VehicleConditionType.NOT_READY_TO_DRIVE;
        case ApiVehicleConditionType.OTHER:
            return VehicleConditionType.OTHER;
    }
};
export const mapToVehicleConditionApi = (type: VehicleConditionType): ApiVehicleConditionType => {
    switch (type) {
        case VehicleConditionType.CONTACT_UNKNOWN:
            return ApiVehicleConditionType.CONTACT_UNKNOWN;
        case VehicleConditionType.NO_KEYS:
            return ApiVehicleConditionType.NO_KEYS;
        case VehicleConditionType.NOT_READY_FOR_PICKUP:
            return ApiVehicleConditionType.NOT_READY_FOR_PICKUP;
        case VehicleConditionType.NOT_ON_SITE:
            return ApiVehicleConditionType.NOT_ON_SITE;
        case VehicleConditionType.NOT_READY_TO_MOVE:
            return ApiVehicleConditionType.NOT_READY_TO_MOVE;
        case VehicleConditionType.NOT_READY_TO_DRIVE:
            return ApiVehicleConditionType.NOT_READY_TO_DRIVE;
        case VehicleConditionType.OTHER:
            return ApiVehicleConditionType.OTHER;
    }
};
